import React, { Fragment } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Form } from 'react-bootstrap';
import keywords from '../Data/keywords';
import 'react-bootstrap-typeahead/css/Typeahead.css';


class TypeaheadKeyword extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  
  handleChange(e) {
    this.props.onKeywordChange(e);
  }

  render() {
    const selected = this.props.keywords;
    const className = this.props.matchAny ? 'typeahead-keyword-any' : 'typeahead-keyword'
    return (
      <Fragment>
        <Form.Group style={{ marginTop: '20px' }}>
          <Typeahead
            allowNew
            id="basic-typeahead-multiple keyword"
            labelKey="name"
            multiple
            onChange={this.handleChange}
            options={keywords}
            placeholder="Choose keyword..."
            selected={selected}
            className={className}
            newSelectionPrefix="Add a new filter: "
            ignoreDiacritics={true}
          />
        </Form.Group>
      </Fragment>
    );
  }
};

export default TypeaheadKeyword;
